// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"5b755c85","348":"5b755c85","2922":"5b755c85","5901":"5b755c85"}[chunkId] + ".chunk.css";
};